import { Icon, IconSizeClasses } from '@eppendorf/vnls-react-components';
import { useTranslation } from 'react-i18next';

import { formatDecimal } from '$shared/utils/charts.utils';

import { useHistoryChartsConfig } from '$features/monitoring/history-charts-v2/useHistoryChartsConfig';

export interface CustomTooltipV2Props {
  active?: boolean;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO: type this
  payload?: any;
  unit: string | null;
  fractionalDigits?: number;
}

export function CustomTooltipV2({
  active,
  payload,
  unit,
  fractionalDigits,
}: CustomTooltipV2Props) {
  const { t } = useTranslation();
  const { showThresholdRefs, chartColors } = useHistoryChartsConfig();
  const bucket = payload.length && payload[0].payload;
  const refPoints = [
    {
      label: t('monitoringDetail.historyChartsDetail.setPointLabel'),
      value: Number.isFinite(bucket?.setPoint)
        ? formatDecimal(bucket.setPoint, fractionalDigits ?? 1)
        : undefined,
      color: chartColors.setPointColor,
      show: Number.isFinite(bucket?.setPoint) && showThresholdRefs,
    },
    // {
    //   label: t('monitoringDetail.historyChartsDetail.minValueLabel'),
    //   value: bucket?.min?.toFixed(fractionalDigits ?? 1),
    //   color: chartColors.setPointColor,
    //   show: Number.isFinite(bucket?.min),
    // },
    // {
    //   label: t('monitoringDetail.historyChartsDetail.maxValueLabel'),
    //   value: bucket?.max?.toFixed(fractionalDigits ?? 1),
    //   color: chartColors.setPointColor,
    //   show: Number.isFinite(bucket?.max),
    // },
    {
      label: t('monitoringDetail.historyChartsDetail.highAlertLabel'),
      value: Number.isFinite(bucket?.alertHigh)
        ? formatDecimal(bucket.alertHigh, fractionalDigits ?? 1)
        : undefined,
      color: chartColors.alertHighLowColor,
      show: Number.isFinite(bucket?.alertHigh) && showThresholdRefs,
    },
    {
      label: t('monitoringDetail.historyChartsDetail.lowAlertLabel'),
      value: Number.isFinite(bucket?.alertLow)
        ? formatDecimal(bucket.alertLow, fractionalDigits ?? 1)
        : undefined,
      color: chartColors.alertHighLowColor,
      show: Number.isFinite(bucket?.alertLow) && showThresholdRefs,
    },
  ];

  const getProcessValueColor = () => {
    const value = bucket.avg;
    if (bucket?.alertHigh && value >= bucket?.alertHigh)
      return chartColors.alertHighLowColor;
    if (bucket?.alertLow && value <= bucket?.alertLow)
      return chartColors.alertHighLowColor;
    return '#60ba05';
  };

  if (active && bucket && payload && payload.length) {
    return (
      <div className="custom-tooltip flex flex__dir--column gap-m font-size-s bg-white p-m border-radius-l bs-shadow-xl color-gray-800">
        <p className="label flex flex__ai--center flex__jc--space-between w-full font-size-xxl font-weight-semibold">
          <span />
          {Number.isFinite(bucket.avg) && (
            <span style={{ color: getProcessValueColor() }}>
              {formatDecimal(bucket.avg, fractionalDigits ?? 1)} {unit}
            </span>
          )}
        </p>
        <div>
          {refPoints.map(
            (item) =>
              item.show && (
                <p
                  key={item.label}
                  className="label flex flex__ai--center flex__jc--space-between w-full color-gray-800"
                >
                  <span>{item.label} </span>
                  <span style={{ color: item.color }}>
                    {item.value} {unit}
                  </span>
                </p>
              ),
          )}
        </div>

        <p className="flex flex__ai--center gap-s">
          <span>
            <Icon name="calendar" size={IconSizeClasses.XXSmall} />
          </span>
          <span>{new Date(bucket.date).toLocaleString()}</span>
        </p>
      </div>
    );
  }

  return null;
}
